import type { Theme } from '@mui/material/styles';

export function getSiteHeaderAppBarSx(theme: Theme, stickyTop: number | string = 0) {
  return {
    background: theme.palette.mode === 'dark'
      ? 'linear-gradient(90deg, #1e293b 0%, #3b82f6 100%)'
      : 'linear-gradient(90deg, #ffffff 0%, #60a5fa 100%)',
    color: 'text.primary',
    top: stickyTop,
    zIndex: theme.zIndex.appBar,
    borderRadius: 0,
  };
}

export const headerUtilityIconButtonSx = {
  p: { xs: 1, sm: 1 },
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    transform: 'scale(1.05)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  transition: 'all 0.2s ease-in-out',
} as const;

export const headerMobileMenuButtonSx = {
  ml: 0,
  mr: { xs: 0.5, sm: 0.5, md: 2 },
  display: { lg: 'none' },
  p: { xs: 1, sm: 1 },
  borderRadius: 2,
  backgroundColor: 'rgba(0, 0, 0, 0.04)',
  border: '1px solid rgba(0, 0, 0, 0.08)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
    transform: 'scale(1.05)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  transition: 'all 0.2s ease-in-out',
} as const;
